import theme from '../../theme/theme';

const {
  colors: {
    any_button,
    black_text,
    white_text,
    box_shadow,
    subtitle,
    stars_rated,
    divider,
    star_white,
  },
} = theme;

const styles = {
  container: {
    flexDirection: 'column',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    paddingRight: '.2em',
    paddingBottom: '.5em',
  },

  title__container: {
    display: 'flex',
    flex: 1,
  },

  title: {
    color: black_text,
    fontSize: '1.250em',
    fontWeight: 'normal',
    letterSpacing: '-0.031em',
    paddingLeft: '0.6em',
    paddingBottom: '1em',
  },

  subtitle: {
    color: subtitle,
    fontSize: '1.250em',
    fontWeight: 'normal',
    letterSpacing: '-0.031em',
    paddingLeft: '0.563em',
    paddingBottom: '1em',
  },

  scroll__wheel: {
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    display: 'block',
    paddingBottom: '.5em',
    paddingRight: '1.9em',
  },

  any__button: {
    boxShadow: `0 0.250em .5em 0 ${box_shadow}`,
    backgroundColor: `${any_button} !important`,
    borderRadius: '0.2em',
    height: '4.4em',
    width: '9.3em',
    textTransform: 'capitalize',
    padding: 0,
  },

  any__text: {
    fontSize: '1.825em',
    color: white_text,
  },

  rating__button: {
    borderRadius: 0,
    height: '4em',
    width: '9.3em',
    padding: 0,
    color: subtitle,
    borderRight: `1px solid ${divider}`,
  },

  rating__wrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  rating__text: {
    fontSize: '1.650em',
    color: subtitle,
    display: 'flex',
    textTransform: 'capitalize',
  },

  star__rated: {
    color: stars_rated,
    fontSize: '1.3em',
    padding: 0,
  },

  star__rated__white: {
    color: star_white,
    fontSize: '1.3em',
    padding: 0,
  },
};

export default styles;
